// removed by extract-text-webpack-plugin
module.exports = {"subnav":"src-components-modules-DevHeader-DevSubNav-style----general-module---subnav---2Xm6w bg-white boxShadow-subtle paddingLeftRight-m paddingTopBottom-s position-fixed width-100 transitionDuration-m zi-chrome","hasNotScrolled":"src-components-modules-DevHeader-DevSubNav-style----general-module---hasNotScrolled---13KFw","hasScrolled":"src-components-modules-DevHeader-DevSubNav-style----general-module---hasScrolled---3-MRD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/DevHeader/DevSubNav/style/general.module.css
// module id = 1449
// module chunks = 168707334958949